// extracted by mini-css-extract-plugin
export default {"tabWrapper":"tab_tabWrapper__DEbH0","tab":"tab_tab__I+jux","tabTitle":"tab_tabTitle__jhQ6w","activeTab":"tab_activeTab__zz4f8","parentTabWrapper":"tab_parentTabWrapper__o-KBT"};